const filterMonthlyPhases = data => {
  // Organizar os dados por fase
  const phaseCounts = [
    'CADASTRO',
    'DESCLASSIFICADO',
    'GANHOS',
    'MONITORAMENTO',
    'NÃO GANHOU',
    'NÃO PARTICIPOU',
    'PREPARAÇÃO',
    'SEM INTERESSE',
  ].map(phase => ({
    label: phase,
    value: data.filter(item => item.phase === phase).length,
  }))

  // Definir as cores de fundo para cada fase
  const backgroundColor = phaseCounts.map((_, index) => (
    index === 0 ? '#28a745' : '#005C96'
  ))

  // Estrutura do gráfico
  return {
    labels: phaseCounts.map(item => item.label),
    datasets: [{
      label: 'Fases no mês',
      data: phaseCounts.map(item => item.value),
      backgroundColor,
    }],
  }
}

export default filterMonthlyPhases
